import * as React from "react";
import { useNavigate } from "react-router-dom";
import { AppSettings } from "../AppSettings";
import { User } from "../Interface/IUser";
import { Message } from "../Interface/Message";
import AlertBox from "./CommonComponent/AlertBox";
import Loader from "./Loader";
import { mdmAccesses } from "../Interface/Role";
import { Button } from "@mui/material";
 
function Home() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = React.useState<User>({
    id: 0,
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    email: "",
    createdBy: "",
    passwordResetRequired: false,
    passwordResetAlertMessage: "",
    isActive: true,
    isMDMActive:false,
    roleID: "",
    userType: "",
    token: "",
    mdmAccesses:[],

  });

  const [alertBoxmsg, setAlertBoxmsg] = React.useState<Message>({
    Type: "",
    Text: "",
  });

  const [openLoader, setOpenloader] = React.useState(false);

  function getQueryValue() {
    return new URLSearchParams(window.location.search);
  }
  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    if (useEffectCount.current) {
      useEffectCount.current = false;

      if (localStorage.getItem("user-info-lpa") !== null) {
        var currentUser = JSON.parse(
          localStorage.getItem("user-info-lpa") || " "
        );
        if (currentUser !== " ") {
          setUserInfo(currentUser);
          window.location.href = "/Services";
        }
      } else {
        // sso login ..
        let queryValue = getQueryValue().get("code");
        if (queryValue === null) {
          return;
        }

        let apiUrl =
          AppSettings.API_URL + "User/LogInBySSOCode?code=" + queryValue;

        setOpenloader(true);
        const requestOptions = {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        };
        fetch(apiUrl, requestOptions)
          .then((response) => response.json())
          .then((data) => {
            if (data.errors == undefined) {
              localStorage.setItem("user-info-lpa", JSON.stringify(data));
              SaveUserInfo();
              window.location.href = "/Services";
            } else {
              let msg: Message = { Text: "", Type: "" };
              msg = { Text: data.errors[0], Type: "Error" };
              setAlertBoxmsg(msg);
            }
            setOpenloader(false);
          })
          .catch((err) => {
            let msgError: Message = {
              Text: `API Error, ${err.message}`,
              Type: "Error",
            };
            setAlertBoxmsg(msgError);
          })
          .finally(() => {
            setOpenloader(false);
          });
        //sso login end
      }
    }
  }, []);

  function handleSSOSubmit() {
    window.location.replace(AppSettings.SSO_URL);
  }

  function SaveUserInfo() {
    if (localStorage.getItem("user-info-lpa") !== null) {
      var currentUser = JSON.parse(
        localStorage.getItem("user-info-lpa") || " "
      );
      if (currentUser !== " ") {
        setUserInfo(currentUser);
      }
    }
  }

  return (
    <div className="main-container">
      <Loader value={openLoader}></Loader>
      <div className="container-text">
        <p className="home-page-heading">DSV Lead Logistics</p>
        <p className="transform-text">
          Let us transform your supply chains
          <br />
          -strategically, tactically and operationally.
        </p>
        <br></br>
        {alertBoxmsg.Text !== "" && (
          <div className="error-Msg-Home">
            <AlertBox value={alertBoxmsg}></AlertBox>
          </div>
        )}
        <Button 
          variant="outlined"
          sx={{background: "white", fontWeight: "bold", minWidth: 120}}
          onClick={() => handleSSOSubmit()}
          size="large"
         >
          Log In
        </Button>
      </div>
    </div>
  );
}

export default Home;
function useQuery() {
  throw new Error("Function not implemented.");
}
